import React, { Fragment } from 'react';
import { InView } from 'react-intersection-observer';
import PropTypes from 'prop-types';
import './video-module.scss';
import { isValid, decodeTags } from '../../../../utils';

const Video = ({ data, isMobile }) => {
  if (!isValid(data)) { return null; }
    const {
      url,
      credit,
      description,
      title,
      autoplay,
      loop,
      muted,
      playbackControls,
      playInline
  } = data;

  return (
     <div className="video-container">
      <video
        title={title}
        aria-label={description}
        controls={playbackControls}
        autoPlay={autoplay}
        loop={loop}
        muted={muted}
        playsInline={isMobile || playInline}>
  		  <source src={url} />
	    </video>
      <div className="video-credit-container">
          <span className="video-credit" dangerouslySetInnerHTML={ { __html: decodeTags(credit) } }></span>
      </div>
    </div>
  );
};

Video.propTypes = {
  className: PropTypes.string,
};

export default Video;
